//Dashboard
import Apps from "../pages/Apps";

//login
import Login from "../pages/Authentication/Login";
import Synchronisation from "pages/Authentication/Synchronisation";
//Other
import FAQ from "../pages/FAQ/FAQ";
import PrivacyPolicy from "pages/PrivacyPolicy/PrivacyPolicy";
import PSGP from "pages/PSGP/PSGP";
import Apps2 from "apps2";

const authProtectedRoutes = [{ path: "/apps", component: <Apps /> }];

const publicRoutes = [
  { path: "/", component: <Apps /> },
  { path: "/login", component: <Login /> },
  { path: "/apps2", component: <Apps2 /> },
  { path: "/resync", component: <Synchronisation /> },
  { path: "/FAQ", component: <FAQ /> },
  { path: "/privacy-policy", component: <PrivacyPolicy /> },
  { path: "/PSGP", component: <PSGP /> },
];

export { authProtectedRoutes, publicRoutes };
